<template>
  <!-- Se relee cada vez que se muestra, no solo al crearla: al volver atrás (p. ej., desde la oferta
       en la que se acaba de pedir) la página sigue montada, y con `page:init` enseñaba la cola de antes. -->
  <f7-page name="facturacion-autorizaciones" @page:beforein="cargar">
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <!-- El mismo rótulo que la tarjeta del menú de FACTURACIÓN que lleva aquí. -->
      <f7-nav-title>OEE · Autorizaciones</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="cargar" icon-f7="arrow_2_circlepath" :class="{ 'enlace-apagado': cargando }" style="color:#c8d3e5"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="sello-datos-bar" v-if="bandeja"><sello-datos estado="vivo" /></div>

    <div class="aut-cabecera">
      <div class="aut-lema">
        Lo que retrasa o anula una factura no se aplica hasta que lo autoriza la persona a la que está asignado.
        <template v-if="bandeja && bandeja.administrador">
          Como Administrador ves todas las peticiones, con a quién está asignada cada una, y puedes resolver cualquiera
          que no hayas pedido tú: quedará anotado que lo hiciste como administrador.
        </template>
        <template v-else>Aquí salen solo las peticiones que te toca autorizar a ti.</template>
      </div>
      <div v-if="bandeja && bandeja.totalPendientes" class="aut-insignia">
        {{ bandeja.totalPendientes }} pendiente{{ bandeja.totalPendientes == 1 ? '' : 's' }}
        · la más antigua, {{ haceCuanto(bandeja.pendienteMasAntigua) }}
      </div>
    </div>

    <div v-if="error" class="aut-aviso aut-aviso-error">No se ha podido leer la cola: {{ error }}</div>

    <!-- §9 · quien no autoriza a nadie no ve la cola, y aquí se le dice por qué, quién decide y dónde. -->
    <div v-if="bandeja && !bandeja.puedeResolver" class="aut-aviso aut-aviso-info">
      No tienes peticiones que autorizar: cada una la resuelve la persona a la que se asignó al pedirla, y a ti no
      te asigna ninguna la configuración de autorizaciones. Quien no tiene a nadie asignado lo pide a los
      autorizadores generales, {{ autorizadores }}.
      <!-- A quien administra no se le manda a pedírselo a Dirección: se le dice dónde se decide. -->
      <template v-if="administra">
        {{ bandeja.dondeSeDaElPermiso }}
        <f7-link v-if="puedeAbrirAjustes" :href="rutaAjustes">Abrir Ajustes › Autorizaciones de condiciones de facturación</f7-link>
      </template>
      <template v-else>Si crees que deberías autorizar, pídeselo a Dirección.</template>
    </div>

    <div class="aut-filtros" v-if="bandeja">
      <div v-for="f in filtros" :key="f.id" class="aut-filtro-grupo">
        <button type="button" class="aut-filtro" :class="{ activo: filtro == f.id, 'aut-filtro-inactivo': f.activaLa }" @click="filtro = f.id">
          {{ f.nombre }}<template v-if="f.cuenta !== null"> ({{ f.cuenta }})</template>
        </button>
        <!-- §9 · un tipo que todavía no existe lo dice junto a su botón, y qué tarea lo activa. -->
        <span v-if="f.activaLa" class="aut-filtro-nota">Aún no activo · lo activa {{ f.activaLa }}</span>
      </div>
    </div>

    <div class="aut-lista" v-if="bandeja">
      <div v-if="!visibles.length" class="aut-vacia">{{ mensajeVacio }}</div>
      <div v-for="s in visibles" :key="s.id" class="aut-tarjeta" :class="'aut-tipo-' + s.tipo">
        <div class="aut-cuerpo">
          <div class="aut-titulo">
            <span class="aut-etiqueta" :class="'aut-etiqueta-' + s.tipo">{{ s.tipoEtiqueta }}</span>
            {{ s.titulo }}
          </div>
          <div class="aut-documento">
            <f7-link v-if="s.idDocumento" :href="rutaDocumento(s)">{{ s.documento == 'OFERTA' ? 'Oferta' : 'Pedido' }} {{ s.codigoDocumento }}</f7-link>
            <template v-if="s.numeroLinea !== null && s.numeroLinea !== undefined"> · línea {{ s.numeroLinea }}</template>
            <template v-if="s.nombreCliente"> · {{ s.nombreCliente }}</template>
            <template v-if="s.numeroLineas"> · {{ s.numeroLineas }} línea{{ s.numeroLineas == 1 ? '' : 's' }}</template>
            <template v-if="s.importe !== null && s.importe !== undefined"> · {{ euros(s.importe) }}</template>
          </div>
          <div class="aut-motivo" v-if="s.motivo">«{{ s.motivo }}»</div>
          <div class="aut-pie">
            Pide {{ s.nombreSolicitante || s.solicitante }} · {{ haceCuanto(s.fechaSolicitud) }}
            <template v-if="s.efecto"> · efecto: {{ s.efecto }}</template>
            <template v-if="s.nombresAutorizadores"> · asignada a {{ s.nombresAutorizadores }}</template>
          </div>
          <div class="aut-aviso aut-aviso-info" v-if="s.estado == 'PENDIENTE' && s.aclaracion">
            Aclaración pedida: «{{ s.aclaracion }}». Sigue pendiente hasta que se autorice o se rechace.
          </div>
          <div class="aut-resolucion" v-if="s.estado != 'PENDIENTE'">
            <strong>{{ s.estadoNombre }}</strong>
            <template v-if="s.nombreResolutor"> por {{ s.nombreResolutor }}</template>
            · {{ fechaHora(s.fechaResolucion) }}
            <template v-if="s.motivoResolucion"> · «{{ s.motivoResolucion }}»</template>
          </div>
        </div>
        <div class="aut-acciones" v-if="s.estado == 'PENDIENTE' && s.puedeResolverla">
          <button type="button" class="aut-boton aut-autorizar" :disabled="enCurso == s.id" @click="autorizar(s)">Autorizar</button>
          <div class="aut-acciones-fila">
            <button type="button" class="aut-boton aut-aclaracion" :disabled="enCurso == s.id" @click="aclaracion(s)">Pedir aclaración</button>
            <button type="button" class="aut-boton aut-rechazar" :disabled="enCurso == s.id" @click="rechazar(s)">Rechazar…</button>
          </div>
        </div>
        <!-- Al Administrador le salen todas, también las que pidió él: en esas, en vez de botones, el porqué. -->
        <div class="aut-acciones aut-sin-acciones" v-else-if="s.estado == 'PENDIENTE' && s.motivoNoPuedeResolverla">
          {{ s.motivoNoPuedeResolverla }}
        </div>
      </div>
    </div>

    <div class="aut-nota" v-if="bandeja">
      Rechazar pide motivo y se lo comunica por correo a quien lo pidió. Cada decisión queda en el historial del pedido
      o de la oferta con quién, cuándo y por qué.
    </div>
  </f7-page>
</template>

<script>
import SelloDatos from '../../components/SelloDatos.vue';
import Autorizaciones from '../../js/db/Autorizaciones.js';
import Utils from '../../js/Utils.js';
import { AUTORIZADORES_POR_DEFECTO } from '../../js/condicionesFacturacion.js';
import { puedeAbrirAjustesAutorizaciones, RUTA_AJUSTES_AUTORIZACIONES } from '../autorizacionescondiciones/permisos.js';

/**
 * Tipos de la cola que todavía no pide nadie, y la tarea que los enchufa. Cuando se mezcle cada
 * una, su tipo sale de aquí: si no, su pestaña diría «aún no activo» con peticiones dentro.
 */
const TIPOS_SIN_ACTIVAR = {
  NO_FACTURAR: 'ACEL-2b (#910)',
  SERVICIO_SIN_EXPEDIENTE: 'ACEL-0c (#899)'
};

/** Quien administra la aplicación: a ellos el aviso les dice dónde se da el permiso. */
const ROLES_QUE_ADMINISTRAN = ['ADMIN', 'DIRECTOR'];

/**
 * P04 · OEE › Autorizaciones (#905): la cola de lo que retrasa o anula una factura.
 *
 * Los contadores de los filtros salen de la misma respuesta que las tarjetas, para que el número y
 * lo que se ve no puedan decir cosas distintas. La API manda las que están asignadas a quien mira, o
 * todas si es Administrador; quién puede decidir cada una lo contesta ella (`puedeResolverla`, con su
 * porqué) y lo vuelve a comprobar en cada acción.
 */
export default {
  components: { SelloDatos },
  data: function () {
    return {
      bandeja: null,
      cargando: false,
      error: null,
      filtro: 'PENDIENTES',
      enCurso: null,
      rutaAjustes: RUTA_AJUSTES_AUTORIZACIONES
    };
  },
  computed: {
    autorizadores: function () {
      return (this.bandeja && this.bandeja.autorizadores) || AUTORIZADORES_POR_DEFECTO;
    },
    puedeAbrirAjustes: function () {
      return puedeAbrirAjustesAutorizaciones();
    },
    administra: function () {
      const user = Utils.getUser();
      const roles = (user && user.roles) || [];
      return ROLES_QUE_ADMINISTRAN.some(r => roles.indexOf(r) > -1);
    },
    filtros: function () {
      const b = this.bandeja || { pendientesPorTipo: {} };
      const porTipo = b.pendientesPorTipo || {};
      return [
        { id: 'PENDIENTES', nombre: 'Pendientes', cuenta: b.totalPendientes || 0 },
        { id: 'CONDICION_FACTURACION', nombre: 'Condiciones de facturación', cuenta: porTipo.CONDICION_FACTURACION || 0 },
        { id: 'NO_FACTURAR', nombre: 'No facturar', cuenta: porTipo.NO_FACTURAR || 0, activaLa: TIPOS_SIN_ACTIVAR.NO_FACTURAR },
        { id: 'SERVICIO_SIN_EXPEDIENTE', nombre: 'Servicio sin expediente', cuenta: porTipo.SERVICIO_SIN_EXPEDIENTE || 0,
          activaLa: TIPOS_SIN_ACTIVAR.SERVICIO_SIN_EXPEDIENTE },
        { id: 'SEGUNDA_A_CERO', nombre: 'Segunda a 0 €', cuenta: porTipo.SEGUNDA_A_CERO || 0 },
        { id: 'RESUELTAS', nombre: 'Resueltas', cuenta: null }
      ];
    },
    /** Cada pestaña dice lo suyo cuando está vacía; las de tipos que aún no existen, qué los activa. */
    mensajeVacio: function () {
      const f = this.filtros.find(x => x.id == this.filtro) || {};
      if (f.activaLa) {
        return 'No hay peticiones de «' + f.nombre + '»: este tipo todavía no está activo. Lo activa ' + f.activaLa
          + ', y desde entonces sus peticiones saldrán aquí.';
      }
      const deQuien = this.bandeja && this.bandeja.administrador ? '' : ' a tu nombre';
      if (this.filtro == 'CONDICION_FACTURACION') {
        return 'No hay condiciones de facturación pendientes de autorizar' + deQuien
          + '. Se piden desde Pago y Finanzas › Condiciones de facturación de la oferta o del pedido.';
      }
      if (this.filtro == 'SEGUNDA_A_CERO') {
        return 'No hay segundas a 0 € pendientes de autorizar' + deQuien
          + '. Se piden desde el aviso «La segunda de esta línea sale a 0 €» de la oferta o del pedido.';
      }
      if (this.filtro == 'RESUELTAS') return 'Todavía no hay solicitudes resueltas' + deQuien + '.';
      return 'No hay solicitudes pendientes' + deQuien + '.';
    },
    visibles: function () {
      if (!this.bandeja) return [];
      if (this.filtro == 'RESUELTAS') return this.bandeja.resueltas || [];
      const pendientes = this.bandeja.pendientes || [];
      if (this.filtro == 'PENDIENTES') return pendientes;
      return pendientes.filter(s => s.tipo == this.filtro);
    }
  },
  methods: {
    cargar: function () {
      const self = this;
      if (self.cargando) return;
      self.cargando = true;
      self.error = null;
      return Autorizaciones.bandeja().then(function (res) {
        self.bandeja = res;
      }).catch(function (e) {
        self.error = (e && e.message) || 'error desconocido';
      }).then(function () {
        self.cargando = false;
      });
    },
    /** Si el Administrador va a resolver algo que no tiene asignado, se le dice antes de que lo haga. */
    comoAdministrador: function (s) {
      const u = (Utils.getUser() || {}).username || '';
      const suya = (s.autorizadores || []).some(a => (a || '').toUpperCase() == u.toUpperCase());
      return this.bandeja && this.bandeja.administrador && !suya && s.nombresAutorizadores
        ? ' Está asignada a ' + s.nombresAutorizadores + ': quedará anotado que lo has hecho tú como administrador.'
        : '';
    },
    autorizar: function (s) {
      const self = this;
      self.$f7.dialog.confirm('Se aplicará «' + s.titulo + '» en ' + self.nombreDocumento(s) + '.' + self.comoAdministrador(s), 'Autorizar', function () {
        self.ejecutar(s, Autorizaciones.autorizar(s.id), 'Autorizada');
      });
    },
    rechazar: function (s) {
      const self = this;
      self.$f7.dialog.prompt('Motivo del rechazo. Se le manda por correo a ' + (s.nombreSolicitante || s.solicitante) + '.' + self.comoAdministrador(s), 'Rechazar', function (motivo) {
        if (!motivo || !motivo.trim()) {
          self.$f7.dialog.alert('Para rechazar hay que escribir el motivo.');
          return;
        }
        self.ejecutar(s, Autorizaciones.rechazar(s.id, motivo.trim()), 'Rechazada');
      });
    },
    aclaracion: function (s) {
      const self = this;
      self.$f7.dialog.prompt('Qué necesitas que te aclaren. Se le manda por correo a ' + (s.nombreSolicitante || s.solicitante) + ' y la solicitud sigue pendiente.', 'Pedir aclaración', function (pregunta) {
        if (!pregunta || !pregunta.trim()) {
          self.$f7.dialog.alert('Escribe la pregunta.');
          return;
        }
        self.ejecutar(s, Autorizaciones.pedirAclaracion(s.id, pregunta.trim()), 'Aclaración pedida');
      });
    },
    ejecutar: function (s, peticion, textoOk) {
      const self = this;
      self.enCurso = s.id;
      peticion.then(function () {
        self.$f7.toast.create({ text: textoOk, position: 'center', closeTimeout: 2000, destroyOnClose: true }).open();
      }).catch(function (e) {
        self.$f7.dialog.alert((e && e.message) || 'No se ha podido completar.');
      }).then(function () {
        self.enCurso = null;
        // Se relee siempre: si otra persona se adelantó, lo que se ve tiene que ser lo que hay.
        self.cargar();
      });
    },
    nombreDocumento: function (s) {
      return (s.documento == 'OFERTA' ? 'la oferta ' : 'el pedido ') + (s.codigoDocumento || '');
    },
    rutaDocumento: function (s) {
      return (s.documento == 'OFERTA' ? '/ofertas/view/' : '/pedidos/view/') + s.idDocumento + '/';
    },
    euros: function (importe) {
      return Number(importe).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    },
    fechaHora: function (fecha) {
      if (!fecha) return '';
      const d = new Date(fecha);
      return d.toLocaleDateString('es-ES') + ' ' + d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },
    haceCuanto: function (fecha) {
      if (!fecha) return '';
      const d = new Date(fecha);
      const hoy = new Date();
      const inicio = x => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
      const dias = Math.round((inicio(hoy) - inicio(d)) / 86400000);
      if (dias <= 0) return 'hoy ' + d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
      if (dias == 1) return 'ayer';
      return 'hace ' + dias + ' días';
    }
  }
};
</script>

<style scoped>
.sello-datos-bar { padding: 6px 16px 0; }
.aut-cabecera { display: flex; justify-content: space-between; align-items: center; gap: 12px; flex-wrap: wrap; padding: 10px 16px 0; }
.aut-lema { font-size: 13px; color: #7c8db0; }
.aut-insignia { background: #FAEEDA; color: #8a5a0b; border-radius: 12px; padding: 4px 12px; font-size: 12px; font-weight: 600; }
.aut-aviso { margin: 10px 16px 0; padding: 10px 12px; border-radius: 6px; font-size: 13px; border-left: 4px solid; }
.aut-aviso-info { background: #E9F0FA; border-left-color: #185FA5; color: #1a2744; }
.aut-aviso-error { background: #FAECE7; border-left-color: #D85A30; color: #7a2d14; }
.aut-tarjeta .aut-aviso { margin: 8px 0 0; }
.aut-filtros { display: flex; flex-wrap: wrap; gap: 8px; padding: 14px 16px 4px; }
/* Ancho propio: el `button { width: 100% }` de Framework7 estiraría cada filtro a la fila entera. */
.aut-filtro { width: auto; border: 1px solid #d0d5e0; background: white; border-radius: 16px; padding: 6px 14px; font-size: 12px; font-weight: 600; color: #1a2744; cursor: pointer; }
.aut-filtro.activo { background: #1a2744; color: white; border-color: #1a2744; }
.aut-filtro-grupo { display: inline-flex; align-items: center; gap: 6px; }
.aut-filtro-inactivo { border-style: dashed; color: #7c8db0; }
.aut-filtro-nota { font-size: 11px; color: #7c8db0; white-space: nowrap; }
.aut-sin-acciones { font-size: 12px; color: #4a5672; background: #F4F6FA; border-radius: 6px; padding: 8px 10px; align-self: flex-start; }
.aut-lista { padding: 8px 16px; }
.aut-vacia { padding: 24px; text-align: center; color: #7c8db0; background: white; border: 1px solid #e0e0e0; border-radius: 10px; }
.aut-tarjeta { display: flex; gap: 16px; justify-content: space-between; background: white; border: 1px solid #e0e0e0; border-left: 4px solid #C8862A; border-radius: 10px; padding: 14px 16px; margin-bottom: 12px; }
.aut-tarjeta.aut-tipo-NO_FACTURAR { border-left-color: #D85A30; }
.aut-tarjeta.aut-tipo-SERVICIO_SIN_EXPEDIENTE { border-left-color: #185FA5; }
.aut-tarjeta.aut-tipo-SEGUNDA_A_CERO { border-left-color: #7A4FB5; }
.aut-cuerpo { flex: 1; min-width: 0; }
.aut-titulo { font-weight: 600; color: #1a2744; font-size: 15px; }
.aut-etiqueta { font-size: 11px; border-radius: 10px; padding: 2px 8px; margin-right: 6px; font-weight: 600; background: #FAEEDA; color: #8a5a0b; }
.aut-etiqueta-NO_FACTURAR { background: #FAECE7; color: #a33b1b; }
.aut-etiqueta-SERVICIO_SIN_EXPEDIENTE { background: #E9F0FA; color: #185FA5; }
.aut-etiqueta-SEGUNDA_A_CERO { background: #F1EAFA; color: #5B3A8C; }
.aut-documento { margin-top: 4px; font-size: 13px; color: #1a2744; }
.aut-motivo { margin-top: 4px; font-size: 13px; color: #4a5672; }
.aut-pie { margin-top: 4px; font-size: 12px; color: #7c8db0; }
.aut-resolucion { margin-top: 6px; font-size: 12px; color: #1a2744; }
.aut-acciones { width: 260px; flex-shrink: 0; display: flex; flex-direction: column; gap: 8px; }
.aut-acciones-fila { display: flex; gap: 8px; }
.aut-boton { flex: 1; border-radius: 6px; padding: 9px 10px; font-weight: 600; cursor: pointer; font-size: 13px; background: white; }
.aut-boton:disabled { opacity: 0.55; cursor: default; }
.aut-autorizar { background: #0F6E56; color: white; border: 1px solid #0F6E56; }
.aut-aclaracion { border: 1px solid #185FA5; color: #185FA5; }
.aut-rechazar { border: 1px solid #a33b1b; color: #a33b1b; }
.aut-nota { padding: 4px 16px 24px; font-size: 12px; color: #7c8db0; }
.enlace-apagado { pointer-events: none; opacity: 0.5; }
@media (max-width: 700px) {
  .aut-tarjeta { flex-direction: column; }
  .aut-acciones { width: auto; }
}
</style>
